<script>

    function clickOnItem(eventName) {
        toggleMenu(true);
    }

    function toggleMenu(close) {
        const navbarBurger = document.querySelector('.navbar-burger');

        // Get the target from the "data-target" attribute
        const target = navbarBurger.dataset.target;
        const targetElement = document.getElementById(target);

        if (close) {
            navbarBurger.classList.remove('is-active');
            targetElement.classList.remove('is-active');
        } else {
            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            navbarBurger.classList.toggle('is-active');
            targetElement.classList.toggle('is-active');
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        const navbarBurger = document.querySelector('.navbar-burger');
        navbarBurger.addEventListener('click', () => {
            toggleMenu();
        });
    });

    let screenshots = [
        {image: 'Screenshot_1a.jpg', title: 'Teamaufstellungen.', text: 'Mit Porträts und Statistiken der Spieler.'},
        {image: 'Screenshot_2a.jpg', title: 'Favoriten.', text: 'Folge deinen Clubs und Teams.'},
        {image: 'Screenshot_3a.jpg', title: 'Live.', text: 'Sei bei jedem Spiel mitten drin.'}

    ];
</script>

<main>
    <nav class="navbar is-dark" role="navigation">
        <div class="navbar-brand">
            <a class="navbar-item" href="{'#'}"><img alt="FloorballZ Logo" src="images/favicon.png"></a>
            <a class="navbar-item" href="{'#'}">FloorballZ App</a>

            <a href="{'#'}" role="button" class="navbar-burger" data-target="menuId">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div id="menuId" class="navbar-menu">

            <a class="navbar-item" on:click="{() => clickOnItem('android')}"
               href="https://play.google.com/store/apps/details?id=ch.floorballzteam.floorballz">Android</a>
            <a class="navbar-item" on:click="{() => clickOnItem('apple')}"
               href="https://itunes.apple.com/ch/app/floorballz/id1347992327">Apple iOS</a>
            <a class="navbar-item" on:click="{() => clickOnItem('webapp')}" href="https://app.floorballz.ch">Web-App</a>
            <a class="navbar-item" on:click="{() => clickOnItem('features')}" href="#features">Features</a>
            <a class="navbar-item" on:click="{() => clickOnItem('contact')}" href="#contact">Kontakt</a>
            <a class="navbar-item" on:click="{() => clickOnItem('privacy')}" href="privacy.html">Nutzung</a>
        </div>
    </nav>

    <section class="section has-background-danger">
        <div class="container">
            <div class="columns is-centered">
                <div class="column has-text-centered">
                    <div class="is-size-1-desktop is-size-4-mobile has-text-grey-light">
                        <span class="has-text-white">FloorballZ</span>
                        - die App für das Schweizer Unihockey!
                    </div>
                    <a class="mt-4 button is-info" href="https://app.floorballz.ch">Web-App jetzt testen!</a>
                </div>
            </div>
        </div>
    </section>

    <section class="hero is-large has-bg-img is-dark">
        <div class="hero-body"></div>
    </section>

    <section class="hero is-danger">
        <div class="hero-body">
            <div class="container is-fluid">
                <div class="columns">
                    <div class="column">
                        <h1 class="title has-text-centered">
                            Download now!
                        </h1>
                    </div>
                </div>
                <div class="columns is-centered is-mobile">
                    <div class="column has-text-right slidein_fromleft">
                        <a class="appLink"
                           on:click="{() => clickOnItem('android_b')}"
                           href="https://play.google.com/store/apps/details?id=ch.floorballzteam.floorballz">
                            <img alt="Android Playstore" src="images/android_play_store.png"></a>
                    </div>
                    <div class="column has-text-left slidein_fromright">
                        <a class="appLink"
                           onclick="{() => clickOnItem('apple_b')}"
                           href="https://itunes.apple.com/ch/app/floorballz/id1347992327">
                            <img alt="Apple Store" src="images/ios_app_store.png"></a>
                    </div>
                </div>
            </div>

        </div>
    </section>


    <section class="section has-background-dark">
        <div class="columns" id="features">
            {#each screenshots as screenshot}
                <div class="column is-fluid container">
                    <img alt="App Screenshot" src="images/{screenshot.image}">
                    <div class="has-text-centered">
                        <div class="has-text-info is-size-2-desktop is-size-4-mobile">{screenshot.title}</div>
                        <div class="is-size-5 has-text-grey-light">{screenshot.text}</div>
                    </div>
                </div>
            {/each}
        </div>
    </section>

    <section class="hero is-danger">
        <div class="hero-body">
            <div class="container is-fluid has-text-centered">
                <h1 id="contact" class="title">
                    Kontakt
                </h1>
                <h2 class="subtitle">
                    <a href="mailto:floorballz.team@gmail.com?Subject=Kontakt www.floorballz.ch">floorballz.team@gmail.com</a>
                </h2>
            </div>
        </div>
    </section>


</main>


<style>
    .has-bg-img {
        background: url('../images/functionalGraphic.png') center center;
        background-size: cover;
        min-height: 200px;
    }

    .appLink img {
        width: 25%;
        min-width: 100px;
        margin: 0 10px 0 0;
    }

    .slidein_fromleft {
        animation-duration: 3s;
        animation-name: slideinfromleft;
    }

    .slidein_fromright {
        animation-duration: 3s;
        animation-name: slideinfromright;
    }

    @keyframes slideinfromright {
        from {
            margin-left: 100%;
            width: 300%;
        }
        to {
            margin-left: 0;
            width: 100%;
        }
    }

    @keyframes slideinfromleft {
        from {
            margin-right: 100%;
            width: 300%;
        }

        to {
            margin-right: 0;
            width: 100%;
        }
    }
</style>
